export default "__VITE_ASSET__miCp$rYj__"